/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_TaxonomyInputs */

const en_directory_detail_taxonomy = /** @type {(inputs: Directory_Detail_TaxonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categories and tags`)
};

const zh_directory_detail_taxonomy = /** @type {(inputs: Directory_Detail_TaxonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分类与标签`)
};

/**
* | output |
* | --- |
* | "Categories and tags" |
*
* @param {Directory_Detail_TaxonomyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_taxonomy = /** @type {((inputs?: Directory_Detail_TaxonomyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_TaxonomyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_taxonomy(inputs)
	return zh_directory_detail_taxonomy(inputs)
});
export { directory_detail_taxonomy as "directory.detail.taxonomy" }